import React from 'react';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AppProvider } from './context/AppContext';
import { Layout } from './components/Layout';
import { Home } from './pages/Home';
import { Products } from './pages/Products';
import { ProductDetail } from './pages/ProductDetail';
import { Cart } from './pages/Cart';
import { Checkout } from './pages/Checkout';
import { Orders } from './pages/Orders';
import { Profile } from './pages/Profile';
import { Admin } from './pages/Admin';
const theme = extendTheme({
  colors: {
    brand: {
      50: '#EEF2FF',
      100: '#E0E7FF',
      200: '#C7D2FE',
      300: '#A5B4FC',
      400: '#818CF8',
      500: '#1E3A8A',
      600: '#1E3A8A',
      700: '#172554',
      800: '#0F172A',
      900: '#0C0F1A'
    },
    gold: {
      50: '#FFF9E6',
      100: '#FFF0B3',
      200: '#FFE680',
      300: '#FFD94D',
      400: '#FFCC1A',
      500: '#D4AF37',
      600: '#B8960F',
      700: '#8C720B',
      800: '#604D08',
      900: '#342A04'
    }
  },
  fonts: {
    heading: "'Poppins', system-ui, sans-serif",
    body: "'Poppins', system-ui, sans-serif"
  },
  styles: {
    global: {
      body: {
        bg: '#FAFAFA',
        color: '#1A1A2E'
      }
    }
  },
  components: {
    Button: {
      baseStyle: {
        fontWeight: '600',
        borderRadius: '12px'
      }
    },
    Input: {
      defaultProps: {
        focusBorderColor: 'brand.500'
      }
    }
  }
});
export function App() {
  return <ChakraProvider theme={theme} data-id="element-0">
      <AppProvider data-id="element-1">
        <BrowserRouter data-id="element-2">
          <Routes data-id="element-3">
            <Route path="/" element={<Layout data-id="element-5" />} data-id="element-4">
              <Route index element={<Home data-id="element-7" />} data-id="element-6" />
              <Route path="products" element={<Products data-id="element-9" />} data-id="element-8" />
              <Route path="products/:category" element={<Products data-id="element-11" />} data-id="element-10" />
              <Route path="product/:id" element={<ProductDetail data-id="element-13" />} data-id="element-12" />
              <Route path="cart" element={<Cart data-id="element-15" />} data-id="element-14" />
              <Route path="checkout" element={<Checkout data-id="element-17" />} data-id="element-16" />
              <Route path="orders" element={<Orders data-id="element-19" />} data-id="element-18" />
              <Route path="profile" element={<Profile data-id="element-21" />} data-id="element-20" />
            </Route>
            <Route path="/admin" element={<Admin data-id="element-23" />} data-id="element-22" />
          </Routes>
        </BrowserRouter>
      </AppProvider>
    </ChakraProvider>;
}